import { ConsultingFeePercentageClinicCreate } from '../components/ConsultingFeePercentageClinic/ConsultingFeePercentageClinicCreate';
import { ConsultingFeePercentageClinicEdit } from '../components/ConsultingFeePercentageClinic/ConsultingFeePercentageClinicEdit';

export const ConsultingFeePercentageClinic = {
  create: ConsultingFeePercentageClinicCreate,
  edit: ConsultingFeePercentageClinicEdit
};